import { render } from "./HtmlContent.vue?vue&type=template&id=027b3b84"
import script from "./HtmlContent.vue?vue&type=script&lang=js"
export * from "./HtmlContent.vue?vue&type=script&lang=js"

import "./HtmlContent.vue?vue&type=style&index=0&id=027b3b84&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__